import React from "react";
import { useTranslation } from "react-i18next";

import Civata from "../Components/urunlerimiz/Civata";
import PageHeader from "../Components/common/PageHeader";
import TopBar from "../Components/common/TopBar";
import Spacer4 from "../Components/common/Spacer4";
import useSEO from "../seo/useSEO";

function CivataPage() {
  const { t } = useTranslation();

  useSEO({
    title: "Özel Üretim Civata İmalatı | Aypin Otomat",
    description:
      "Aypin Otomat özel üretim civata çözümleri ve CNC talaşlı imalat hizmetleri hakkında bilgi alın.",
    path: "/civata",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Ürünlerimiz",
        path: "/urunlerimiz",
      },
      {
        name: "Özel Üretim Civatalar",
        path: "/civata",
      },
    ],
  });

  return (
    <>
      <TopBar />

      <Spacer4 />

      <PageHeader
        title={t("Özel Üretim Civatalar")}
      />

      <Civata />
    </>
  );
}

export default CivataPage;